// src/components/BBS/BBSNav.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { key: 'T', label: 'TERMINAL', path: '/' },
  { key: 'S', label: 'ARCHIVES', path: '/archives' },
  { key: 'L', label: 'LINKS', path: '/links' },
  { key: 'G', label: 'GAMES', path: '/games' },
  { key: 'F', label: 'LIVE FEED', path: '/feed' },
  { key: 'B', label: 'SYNC', path: '/subscribe' },

];

export default function BBSNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="bbs-nav">
      {NAV_ITEMS.map(item => {
        const isActive = location.pathname === item.path ||
          (item.path !== '/' && location.pathname.startsWith(item.path));

        return (
          <button
            key={item.key}
            onClick={() => navigate(item.path)}
            className={`bbs-nav-btn ${isActive ? 'active' : ''}`}
            style={item.key === 'F' ? {
              color: isActive ? undefined : '#ff0040',
              borderColor: isActive ? undefined : '#ff0040',
            } : undefined}
          >
            [{item.key}] {item.label}
          </button>
        );
      })}
    </nav>
  );
}